(() => {
  const fallback = 'Kies een beschikbare datum en tijd in de winkelwagen.';
  const pending = new WeakMap();

  async function updatePickup(panel, variantId) {
    const output = panel.querySelector('[data-bb-moment]');
    if (!output || panel.dataset.bbPickup !== 'true') return;
    const token = Symbol('lookup');
    pending.set(panel, token);
    output.textContent = fallback;
    output.classList.remove('is-loading');
    output.classList.remove('is-ready');
    output.setAttribute('aria-busy', 'false');
    if (!variantId || !panel.dataset.bbCollectionTitle || !window.BbZapiet) return;

    output.classList.add('has-zapiet-lookup');
    const shop = panel.dataset.bbShop;
    const item = { product_id: Number(panel.dataset.bbProductId), variant_id: Number(variantId), quantity: 1 };
    const checking = 'Ophaaldag controleren…';
    output.textContent = checking;
    output.classList.add('is-loading');
    output.setAttribute('aria-busy', 'true');
    try {
      const matches = await window.BbZapiet.locationsFor(shop, item);
      const location = window.BbZapiet.resolve(
        matches,
        panel.dataset.bbLocationId,
        panel.dataset.bbCollectionTitle,
        false
      );
      if (!location) return;
      const firstDay = await window.BbZapiet.firstPickupDay(shop, location.id, [item]);
      if (pending.get(panel) !== token || !firstDay) return;
      const date = new Date(`${firstDay}T12:00:00Z`);
      const label = new Intl.DateTimeFormat('nl-NL', {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC',
      }).format(date);
      output.textContent = `Eerst beschikbare ophaaldag: ${label}. Kies je definitieve tijd in de winkelwagen.`;
    } catch (_error) {
      // The cart widget remains the booking source if Zapiet is unavailable here.
    } finally {
      if (pending.get(panel) === token) {
        if (output.textContent === checking) output.textContent = fallback;
        output.classList.remove('is-loading');
        output.classList.add('is-ready');
        output.setAttribute('aria-busy', 'false');
      }
    }
  }

  function updateSize(root) {
    const value = root.querySelector('.bb-size-picker input[type="radio"]:checked')?.value;
    const target = root.querySelector('[data-bb-size-value]');
    if (!value || !target) return;
    const range = value.match(/(\d{2,3})\s*[-–]\s*(\d{2,3})\s*cm\b/i);
    target.textContent = range ? `${range[1]}–${range[2]} cm` : value;
  }

  function setup(scope = document) {
    scope.querySelectorAll('[data-bb-product-certainty]').forEach((panel) => {
      const root = panel.closest('product-info');
      if (!root) return;
      updateSize(root);
      updatePickup(panel, panel.dataset.bbVariantId);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.bb-size-picker input[type="radio"]')) return;
    const root = event.target.closest('product-info');
    if (root) updateSize(root);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const root = document.getElementById(`MainProduct-${data.sectionId}`);
      const panel = root?.querySelector('[data-bb-product-certainty]');
      if (panel) updatePickup(panel, data.variant?.id);
    });
  }
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
